<app-modal-open-padding-wrapper>
  <header #header [ngClass]="{ fixed: headerFixed }">
    <div class="w-100 h-100 logos-wrapper d-flex justify-content-center position-relative">
      <div class="h-100 logo">
        <div class="ms-3 ms-lg-4 h-100 d-flex align-items-center">
          <a [routerLink]="'/'">
            <img [src]="logoUrl" alt="Lenovo Elevate 360" />
          </a>
        </div>
      </div>
      <div class="h-100 container">
        <div class="h-100 row">
          <div class="col-12 p-0 d-flex justify-content-start align-items-center">
            <div class="d-lg-flex justify-content-start align-items-center language-switcher" *ngIf="isDistributor">
              <app-language-switcher></app-language-switcher>
            </div>
            <div class="navbar" *ngIf="(authenticatedUser$ | async) !== null">
              <div
                class="h-100 d-none d-xl-block navbar-wrapper"
                *ngIf="headerMenu && !isDistributor && !hideHeaderMenuItems"
              >
                <div class="h-100 lower-nav d-flex justify-content-start align-items-center">
                  <ng-container *ngFor="let item of headerMenu.items">
                    <ng-container *ngIf="item.items && item.items.length === 0">
                      <div
                        class="h-100 d-flex justify-content-center align-items-center navbar-item me-4"
                        routerLinkActive="active"
                      >
                        <a [routerLink]="item.url" *ngIf="!item.url.includes('http')">
                          <span>{{ item.label }}</span>
                        </a>
                        <a [href]="item.url" target="_blank" *ngIf="item.url.includes('http')">
                          <span>{{ item.label }}</span>
                        </a>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.items && item.items.length > 0">
                      <div
                        class="h-100 d-flex justify-content-center align-items-center navbar-item me-4 dropdown my-accounts"
                        ngbDropdown
                      >
                        <a routerLinkActive="active" class="dropdown-toggle" data-toggle="dropdown" ngbDropdownToggle>{{
                          item.label
                        }}</a>
                        <ul class="dropdown-menu" ngbDropdownMenu>
                          <ng-container *ngFor="let subItem of item.items">
                            <li>
                              <a
                                class="dropdown-item"
                                [routerLink]="subItem.url"
                                *ngIf="!subItem.url.includes('http')"
                                >{{ subItem.label }}</a
                              >
                              <a
                                class="dropdown-item"
                                [href]="subItem.url"
                                target="_blank"
                                *ngIf="subItem.url.includes('http')"
                                >{{ subItem.label }}</a
                              >
                            </li>
                          </ng-container>
                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>

              <div class="d-xl-none w-100 h-100 navbar-wrapper flex-row justify-content-end align-items-center">
                <div class="d-flex justify-content-end align-items-center icons-nav">
                  <div class="mx-3" [ngClass]="!hideHeaderMenuItems ? 'mx-3' : 'mx-0'">
                    <lib-notification-bell-dropdown
                      [iconType]="'light'"
                      [iconTransform]="'grow-3'"
                      *ngIf="!hideHeaderMenuItems"
                    ></lib-notification-bell-dropdown>
                  </div>

                  <app-profile-menu class="mx-3"></app-profile-menu>
                  <app-main-menu
                    [headerMenu]="headerMenu"
                    class="mx-3"
                    *ngIf="!isDistributor && !hideHeaderMenuItems"
                  ></app-main-menu>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="(authenticatedUser$ | async) !== null">
        <div class="h-100 me-3 d-none d-xl-flex justify-content-end align-items-center icons-nav absolute">
          <div class="me-3 d-lg-flex justify-content-end align-items-center language-switcher" *ngIf="!isDistributor">
            <app-language-switcher></app-language-switcher>
          </div>
          <div class="me-3">
            <lib-switch-back-to-admin-button></lib-switch-back-to-admin-button>
          </div>

          <div class="mx-2" [ngClass]="!hideHeaderMenuItems ? 'mx-xxl-3' : 'mx-xxl-0'">
            <lib-notification-bell-dropdown
              [iconType]="'light'"
              [iconTransform]="'grow-4'"
              *ngIf="!hideHeaderMenuItems"
            ></lib-notification-bell-dropdown>
          </div>

          <app-profile-menu class="ms-2 ms-xxl-3"></app-profile-menu>
        </div>
      </div>
    </div>
  </header>
</app-modal-open-padding-wrapper>
